import { useEffect, useState } from "react";
import "@/App.css";
import { AnimatePresence } from "framer-motion";
import { Intro } from "@/components/site/Intro";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { CursorGlow } from "@/components/site/CursorGlow";
import { Conversion } from "@/components/site/Conversion";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [showIntro, setShowIntro] = useState(() => !sessionStorage.getItem("se_intro_seen"));

  useEffect(() => {
    if (!showIntro) sessionStorage.setItem("se_intro_seen", "1");
  }, [showIntro]);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-ink text-white min-h-screen font-sans">
      <BrowserRouter>
        <ScrollManager />
        <AnimatePresence>
          {showIntro && <Intro onDone={() => setShowIntro(false)} />}
        </AnimatePresence>
        <CursorGlow />
        <div className="grain-overlay" aria-hidden="true" />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Conversion />
        <Toaster theme="dark" position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
